import { ChangeEvent } from "react";
import { Box, Divider, Grid, InputAdornment, MenuItem, Typography } from "@mui/material";
import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { ICreateComissaoProdutor } from "src/Contexts/comissoes/ComissoesTypes";
import { FormCore } from "src/Pages/components";
import { AppTextField } from "src/Pages/components/AppFormComponents/AppTextField";
import { AutoCompleteAdministradoras } from "src/Pages/components/AutoCompleted/AutoCompleteAdministradoras";
import { AutoCompleteModalidade } from "src/Pages/components/AutoCompleted/AutoCompleteModalidade";
import { AutoCompleteOperadora } from "src/Pages/components/AutoCompleted/AutoCompleteOperadora";
import { AutoCompleteProdutorActive } from "src/Pages/components/AutoCompleted/AutoCompleteProdutorActive";
import { InfoOutlinedIcon } from "src/Pages/components/Icons/Icons";

import { CardAlerts } from "src/Pages/components/CardAlerts/CardAlerts";


export const handleValidateParcels = (parcels: string[]) => {
  return parcels.every(parcel => parcel === "0" || parcel === "") || parcels.every(parcel => parcel === "");
}

export const FormCommissionProducer = () => {
  const { valuesInputsComissaoProdutor, setValuesInputsComissaoProdutor } =
    useContextComissoes();

  const handleChange =
    (prop: keyof ICreateComissaoProdutor, option?: "limitNumber") =>
      (event: ChangeEvent<HTMLInputElement>) => {
        if (option === "limitNumber") {
          if (event.target.value.length <= 6) {
            setValuesInputsComissaoProdutor({
              ...valuesInputsComissaoProdutor,
              [prop]: event.target.value.replace(",", ""),
            });
          }
        } else {
          setValuesInputsComissaoProdutor({
            ...valuesInputsComissaoProdutor,
            [prop]: event.target.value,
          });
        }
      };

  return (
    <>
      <Typography sx={{ fontSize: "0.9rem", fontWeight: "bold", mb: "1rem" }}>
        Configure os detalhes da grade de comissão
      </Typography>
      <Grid container spacing={2} sx={{ marginBottom: "2rem" }}>
        <Grid item xs={12} md={4} sx={{ '& .MuiFormControl-root': { margin: 0, }, }}>
          <AutoCompleteOperadora
            label="Operadora *"
            fullWidth
            variant="outlined"
            placeholder="Amil, Bradesco, etc."
          />
        </Grid>
        <Grid item xs={12} md={4}
          sx={{ '& .MuiFormControl-root': { margin: 0, }, }}>
          <AutoCompleteAdministradoras
            label="Administradora (Opcional)"
            fullWidth
            variant="outlined"
            placeholder="QualiCorp, etc."

          />
        </Grid>
        <Grid item xs={12} md={4}
          sx={{ '& .MuiFormControl-root': { margin: 0, }, }}>
          <AutoCompleteModalidade
            label="Modalidade *"
            fullWidth
            variant="outlined"
            placeholder="PME, ADESÃO, etc."
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <AppTextField
            label="Vigência *"
            type="date"
            fullWidth
            variant="outlined"
            value={valuesInputsComissaoProdutor?.date_vigencia}
            onChange={handleChange("date_vigencia")}
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <AppTextField
            select
            label="Especial"
            fullWidth
            variant="outlined"
            value={valuesInputsComissaoProdutor?.is_special}
            onChange={handleChange("is_special")}
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
          >
            <MenuItem value="false">Não</MenuItem>
            <MenuItem value="true">Sim</MenuItem>
          </AppTextField>
        </Grid>

        {valuesInputsComissaoProdutor?.is_special === "true" ? (
          <Grid item xs={12} md={6}
            sx={{
              '& .MuiFormControl-root': { margin: 0, },
            }}>
            <AutoCompleteProdutorActive label="Produtores *" fullWidth variant="outlined" placeholder="Selecione o produtor" />
          </Grid>
        ) : (
          <>
            <Grid item xs={12} md={3}>
              <AppTextField
                select
                id="Funcão_Produtor"
                label="Funcão Produtor"
                fullWidth
                variant="outlined"
                value={valuesInputsComissaoProdutor?.funcao_produtor}
                onChange={handleChange("funcao_produtor")}
                sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
              >
                <MenuItem value="CORRETOR">Corretor</MenuItem>
                <MenuItem value="SUPERVISOR">Supervisor</MenuItem>
                <MenuItem value="GERENTE">Gerente</MenuItem>
              </AppTextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <AppTextField
                select
                id="tipo_relatorio"
                label="Tipo Produtor"
                fullWidth
                variant="outlined"
                value={valuesInputsComissaoProdutor?.tipo_produtor}
                onChange={handleChange("tipo_produtor")}
                sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
              >
                <MenuItem value="SALAO">Salão</MenuItem>
                <MenuItem value="REPASSE">Repasse</MenuItem>
                <MenuItem value="FREE_LANCE">Free lance</MenuItem>
                <MenuItem value="CONECTOR">Conector</MenuItem>
                <MenuItem value="ADMINISTRATIVO">Administrativo</MenuItem>

                <MenuItem value="INTERNO">Interno</MenuItem>
                <MenuItem value="HOME">Home</MenuItem>
                <MenuItem value="START">Start</MenuItem>
                <MenuItem value="MOVE">Move</MenuItem>
                <MenuItem value="MASTER">Master</MenuItem>
                <MenuItem value="SALAO_RUBY">Salão Ruby</MenuItem>
                <MenuItem value="SALAO_SAFIRA">Salão Safira</MenuItem>
                <MenuItem value="SALAO_DIAMANTE">Salão Diamante</MenuItem>
                <MenuItem value="GRADE_DF">Grade DF</MenuItem>
                <MenuItem value="GRADE_GO">Grade GO</MenuItem>
                <MenuItem value="GRADE_MT">Grade MT</MenuItem>
                <MenuItem value="GRADE_SP">Grade SP</MenuItem>
                <MenuItem value="SALAO_MG">Salão MG</MenuItem>
                <MenuItem value="EXTERNO_MG">Externo MG</MenuItem>
                <MenuItem value="SALAO_FORTALEZA">Salão Fortaleza</MenuItem>
                <MenuItem value="EXTERNO_FORTALEZA">Externo Fortaleza</MenuItem>
                <MenuItem value="SALAO_BELEM">Salão Belém</MenuItem>
                <MenuItem value="EXTERNO_BELEM">Externo Belém</MenuItem>
                <MenuItem value="SALAO_RECIFE">Salão Recife</MenuItem>
                <MenuItem value="EXTERNO_RECIFE">Externo Recife</MenuItem>
                <MenuItem value="EXTERNO_ESPECIAL_RJ">Externo Especial RJ</MenuItem>
                <MenuItem value="EP_1">EP 1</MenuItem>
                <MenuItem value="EP_2">EP 2</MenuItem>
              </AppTextField>
            </Grid>
          </>
        )}


      </Grid>

      <Divider sx={{ my: "1.4rem" }} />

      <Typography sx={{ fontSize: "0.9rem", mb: "1rem", fontWeight: "bold" }}>
        Selecione as parcelas que geram comissão e defina suas porcentagens.
      </Typography>

      <Grid container spacing={2} sx={{ marginBottom: "2rem" }}>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            label="1Parc."
            variant="outlined"
            fullWidth
            type="text"
            value={valuesInputsComissaoProdutor?.parc_1}
            onChange={handleChange("parc_1", "limitNumber")}
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
          />
        </Grid>

        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            label="2Parc."
            variant="outlined"
            fullWidth
            type="text"
            value={valuesInputsComissaoProdutor?.parc_2}
            onChange={handleChange("parc_2", "limitNumber")}
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            label="3Parc."
            variant="outlined"
            fullWidth
            type="text"

            value={valuesInputsComissaoProdutor?.parc_3}
            onChange={handleChange("parc_3", "limitNumber")}
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            label="4Parc."
            variant="outlined"
            fullWidth
            type="text"
            value={valuesInputsComissaoProdutor?.parc_4}
            onChange={handleChange("parc_4", "limitNumber")}
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            label="5Parc."
            variant="outlined"
            fullWidth
            type="text"
            value={valuesInputsComissaoProdutor?.parc_5}
            onChange={handleChange("parc_5", "limitNumber")}
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            label="6Parc."
            variant="outlined"
            fullWidth
            type="text"
            value={valuesInputsComissaoProdutor?.parc_6}
            onChange={handleChange("parc_6", "limitNumber")}
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            label="7Parc."
            variant="outlined"
            fullWidth
            type="text"
            value={valuesInputsComissaoProdutor?.parc_7}
            onChange={handleChange("parc_7", "limitNumber")}
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            label="8Parc."
            variant="outlined"
            fullWidth
            type="text"
            value={valuesInputsComissaoProdutor?.parc_8}
            onChange={handleChange("parc_8", "limitNumber")}
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            label="9Parc."
            variant="outlined"
            fullWidth
            type="text"
            value={valuesInputsComissaoProdutor?.parc_9}
            onChange={handleChange("parc_9", "limitNumber")}
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            label="10Parc."
            variant="outlined"
            fullWidth
            type="text"
            value={valuesInputsComissaoProdutor?.parc_10}
            onChange={handleChange("parc_10", "limitNumber")}
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            label="11Parc."
            variant="outlined"
            fullWidth
            type="text"
            value={valuesInputsComissaoProdutor?.parc_11}
            onChange={handleChange("parc_11", "limitNumber")}
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            label="12Parc."
            variant="outlined"
            fullWidth
            type="text"
            value={valuesInputsComissaoProdutor?.parc_12}
            onChange={handleChange("parc_12", "limitNumber")}
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
          />
        </Grid>
      </Grid>
      {
        handleValidateParcels([
          valuesInputsComissaoProdutor.parc_1,
          valuesInputsComissaoProdutor.parc_2,
          valuesInputsComissaoProdutor.parc_3,
          valuesInputsComissaoProdutor.parc_4,
          valuesInputsComissaoProdutor.parc_5,
          valuesInputsComissaoProdutor.parc_6,
          valuesInputsComissaoProdutor.parc_7,
          valuesInputsComissaoProdutor.parc_8,
          valuesInputsComissaoProdutor.parc_9,
          valuesInputsComissaoProdutor.parc_10,
          valuesInputsComissaoProdutor.parc_11,
          valuesInputsComissaoProdutor.parc_12
        ]) && (
          < CardAlerts
            title="Parcelas zeradas não geram comissão de pagamento !"
            subTitle="Todas as parcelas que não forem preenchidas serão consideradas como 0% (Zero)"
            color="primary"
            icon={<InfoOutlinedIcon fontSize="small" />}
          />
        )
      }

      <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "1.5rem" }}>
        <InfoOutlinedIcon fontSize="small" />
        <Typography sx={{ fontSize: "0.8rem", }}>
          Se a comissão for vitalícia, defina qual parcela ela passa ser vitalícia.
        </Typography>
      </Box>


      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <AppTextField
            label="Vitalícia começa na parcela "
            fullWidth
            variant="outlined"
            select
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}

            value={valuesInputsComissaoProdutor?.vitalicio}
            onChange={handleChange("vitalicio")}
          >
            <MenuItem value="NONE" sx={{ fontSize: "0.75rem" }}>Nenhuma parcela</MenuItem>
            <MenuItem value="1" sx={{ fontSize: "0.75rem" }}>Começa na 1ª parcela</MenuItem>
            <MenuItem value="2" sx={{ fontSize: "0.75rem" }}>Começa na 2ª parcelas</MenuItem>
            <MenuItem value="3" sx={{ fontSize: "0.75rem" }}>Começa na 3ª parcelas</MenuItem>
            <MenuItem value="4" sx={{ fontSize: "0.75rem" }}>Começa na 4ª parcelas</MenuItem>
            <MenuItem value="5" sx={{ fontSize: "0.75rem" }}>Começa na 5ª parcelas</MenuItem>
            <MenuItem value="6" sx={{ fontSize: "0.75rem" }}>Começa na 6ª parcelas</MenuItem>
            <MenuItem value="7" sx={{ fontSize: "0.75rem" }}>Começa na 7ª parcelas</MenuItem>
            <MenuItem value="8" sx={{ fontSize: "0.75rem" }}>Começa na 8ª parcelas</MenuItem>
            <MenuItem value="9" sx={{ fontSize: "0.75rem" }}>Começa na 9ª parcelas</MenuItem>
            <MenuItem value="10" sx={{ fontSize: "0.75rem" }}>Começa na 10ª parcelas</MenuItem>
            <MenuItem value="11" sx={{ fontSize: "0.75rem" }}>Começa na 11ª parcelas</MenuItem>
            <MenuItem value="12" sx={{ fontSize: "0.75rem" }}>Começa na 12ª parcelas</MenuItem>
          </AppTextField>
        </Grid>
      </Grid>
    </ >
  );
};
